export default __webpack_public_path__ + "static/media/Button_Add_Blue.02b01852.svg";